// extracted by mini-css-extract-plugin
export default {"button":"AddMemberError_button__Z4dyN","iconContainer":"AddMemberError_iconContainer__f2Udi"};